import { render, staticRenderFns } from "./ToggleInput.vue?vue&type=template&id=449472f4&scoped=true&"
import script from "./ToggleInput.vue?vue&type=script&lang=js&"
export * from "./ToggleInput.vue?vue&type=script&lang=js&"
import style0 from "./ToggleInput.vue?vue&type=style&index=0&id=449472f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "449472f4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VSwitch})
